import { bl_mrp_process_template_bom_RowClass } from '../../dbschema/bl_mrp_process_template_bom.model';
import { bl_mrp_process_template_ext_RowClass } from '../../dbschema/bl_mrp_process_template_ext.model';
import { bl_mrp_process_template_hdr_RowClass } from '../../dbschema/bl_mrp_process_template_hdr.model';
import { bl_mrp_process_template_line_RowClass } from '../../dbschema/bl_mrp_process_template_line.model';
import { bl_mrp_process_template_machine_link_RowClass } from '../../dbschema/bl_mrp_process_template_machine_link.model';
import {BaseContainerModel} from '../base-container.model';

export class MrpProcessTemplateContainerModel extends BaseContainerModel {
  bl_mrp_process_template_hdr:  bl_mrp_process_template_hdr_RowClass = new bl_mrp_process_template_hdr_RowClass();
  bl_mrp_process_template_exts:  bl_mrp_process_template_ext_RowClass[] = [];
  bl_mrp_process_template_lines: bl_mrp_process_template_line_RowClass[] = [];
  bl_mrp_process_template_boms: bl_mrp_process_template_bom_RowClass[] = [];
  bl_mrp_process_template_machine_links: bl_mrp_process_template_machine_link_RowClass[] = []
}
